import { render } from "./partner-section.vue?vue&type=template&id=168c0148&scoped=true&ts=true"
import script from "./partner-section.vue?vue&type=script&lang=ts"
export * from "./partner-section.vue?vue&type=script&lang=ts"

import "./partner-section.vue?vue&type=style&index=0&id=168c0148&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168c0148"]])

export default __exports__